import React from 'react'

const SvgHighVoltageFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M10.934 2h6.329c1.901 0 3.018 2.14 1.933 3.7l-1.977 2.844h1.6c2.093.001 3.066 2.601 1.485 3.975L10 21.48c-1.876 1.63-4.617-.512-3.51-2.724l1.526-3.05H7.13c-1.67 0-2.76-1.744-2.043-3.24l3.71-9.096A2.353 2.353 0 0110.934 2z' />
  </svg>
)

export default SvgHighVoltageFilled
